import React, { Fragment, useState, useEffect, useRef } from "react";
import { Redirect } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Button from "@mui/material/Button";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import { Link, Navigate, useNavigate } from "react-router-dom";
import Lottie from "lottie-react";
import loading from "../components/loading.json";
import { themeStyle, themeStyleDark } from "../components/Components";
import { gsap } from "gsap";
import Backdrop from "@mui/material/Backdrop";
import bg from "../bg.mp4";
import Sidebar from "../components/Sidebar";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { Grid } from "@mui/material";
import XIcon from "@mui/icons-material/X";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import EmailIcon from "@mui/icons-material/Email";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import Footer from "../components/Footer";
import CountUp from "react-countup";
import Benchmark from "./Benchmark";
import HistoryIcon from "@mui/icons-material/History";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import SchoolIcon from "@mui/icons-material/School";
import AllInclusiveIcon from "@mui/icons-material/AllInclusive";
import RadarIcon from "@mui/icons-material/Radar";
import CastForEducationIcon from "@mui/icons-material/CastForEducation";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import SelfImprovementIcon from "@mui/icons-material/SelfImprovement";
import SportsBasketballIcon from "@mui/icons-material/SportsBasketball";
import LibraryMusicIcon from "@mui/icons-material/LibraryMusic";
import ClassIcon from "@mui/icons-material/Class";
import CorporateFareIcon from "@mui/icons-material/CorporateFare";
import HistoryEduIcon from "@mui/icons-material/HistoryEdu";
import FavoriteIcon from "@mui/icons-material/Favorite";
import AcUnitIcon from "@mui/icons-material/AcUnit";
import Explore from "./Explore";
import VisitUs from "../components/VisitUs";
import img1 from "../img/bgsimg (1).jpeg";
import img2 from "../img/bgsimg (2).jpeg";
import img3 from "../img/bgsimg (3).jpeg";
import img4 from "../img/bgsimg (4).jpeg";
import img5 from "../img/bgsimg (5).jpeg";
import img6 from "../img/bgsimg (6).jpeg";
import img7 from "../img/bgsimg (7).jpeg";
import img8 from "../img/bgsimg (8).jpeg";

// Create an array of imported images
const images = [
  { image: img1, title: " 1" },
  { image: img2, title: " 2" },
  { image: img3, title: " 3" },
  { image: img4, title: " 4" },
  { image: img5, title: " 5" },
  { image: img6, title: " 6" },
  { image: img7, title: " 7" },
  { image: img8, title: " 8" },
];

export default function Dashboard() {
  const [transition, setTransition] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [newsTranslate, setNewsTranslate] = useState(0);
  const [newsCount, setNewsCount] = useState(1);

  const state = useSelector((state) => state);
  const dispatch = useDispatch();
  const ref = useRef([]);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(-200, -200);
    setTimeout(() => setTransition(true), 500);
    setTimeout(() => {
      gsap.to(".loader", { opacity: 0, duration: 0.1 }).then(() => {
        setIsLoading(false);

        setTimeout(() => {
          gsap.to(".hero, .video, .overlay", {
            opacity: 1,
            duration: 0.1,
          });
          let newsItems = gsap.utils.toArray(".icard");

          newsItems.forEach((item, i) => {
            let hover = gsap.to(item, {
              scale: 1.025,
              color:
                state.auth.theme == "dark"
                  ? themeStyleDark.primaryButtonTextColor
                  : themeStyle.primaryButtonTextColor,
              duration: 0.3,
              paused: true,
              ease: "power2.inOut",
            });
            item.addEventListener("mouseenter", () => {
              hover.play();
            });
            item.addEventListener("mouseleave", () => {
              hover.reverse();
            });
          });
        }, 100);
      });
    }, 500);
  }, []);

  function newsLeft() {
    if (newsCount > 0) {
      gsap.to(".newsSlider", {
        translateX: newsTranslate + 200,
        duration: 0.5,
      });
      setNewsTranslate(newsTranslate + 200);
      setNewsCount(newsCount - 1);
      dispatch({
        type: "NAV_COLOR",
        payload: { navColor: "#000c66", navOpacity: 1 },
      });
    }
  }

  function newsRight() {
    if (newsCount < 2) {
      gsap.to(".newsSlider", {
        translateX: newsTranslate - 200,
        duration: 0.5,
      });
      setNewsTranslate(newsTranslate - 200);
      setNewsCount(newsCount + 1);
      dispatch({
        type: "NAV_COLOR",
        payload: { navColor: "#000c66", navOpacity: 1 },
      });
    }
  }

  function getContent() {
    if (isLoading) {
      return (
        <Lottie
          className="loader"
          style={{ height: "0" }}
          animationData={loading}
          loop={true}
        />
      );
    } else {
      return (
        <div className="main">
          <Sidebar />
          <div className="overlay"></div>
          <div
            style={{
              height: "75px",
              width: "75px",
              borderRadius: "40px",
              backgroundColor: "black",
              position: "fixed",
              right: 20,
              zIndex: 4,
              bottom: 20,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              opacity: 0,
            }}
            onClick={() => {
              window.scrollTo(0, 0);
            }}
            className="takemeup"
          >
            <ArrowUpwardIcon style={{ color: "white", fontSize: "40px" }} />
          </div>
          <video
            src={bg}
            type="video/mp4"
            autoPlay
            loop
            muted
            id="video"
            className="video"
          />{" "}
          <div
            className="herotitle"
            style={{
              marginTop: state.auth.isMobile ? "-90vh" : "-65vh",
              marginBottom: "50vh",
              textAlign: "center",
              height: "200px",
              width: "100vw",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontSize: state.auth.isMobile ? "40px" : "75px",
              fontWeight: "bold",
              fontFamily: "Montserrat",
              textShadow: "8px 8px 8px black",
              color:
                state.auth.theme == "dark"
                  ? themeStyleDark.primaryButtonTextColor
                  : themeStyle.primaryButtonTextColor,
            }}
          >
            WELCOME TO BGS WORLD SCHOOL
          </div>
          <div
            className="hero"
            style={{ paddingTop: state.auth.isMobile ? "150px" : "0px" }}
          >
            <div
              style={{
                fontSize: state.auth.isMobile ? "30px" : "35px",
                fontWeight: "bold",
                fontFamily: "Montserrat",
                color: "#0e86d4",
                marginTop: state.auth.isMobile ? "0px" : "50px",
              }}
            >
              BGS WORLD SCHOOL
            </div>
            <br />
            <br />
            <div
              style={{
                textAlign: "justify",
                fontSize: state.auth.isMobile ? "16px" : "20px",
                fontWeight: "bold",
                fontFamily: "Montserrat",
                marginBottom: "30px",
              }}
            >
              We develop Pre-10th students into unstoppable learners and leaders
              who are inspired to make an impact, determined to fulfill their
              potential, and driven to take control of their futures.
            </div>
            <div
              onClick={() => navigate("about_school")}
              style={{
                marginBottom: "100px",
                cursor: "pointer",
                textAlign: "left",
                fontSize: state.auth.isMobile ? "16px" : "20px",
                fontWeight: "bold",
                color:
                  state.auth.theme == "dark"
                    ? themeStyleDark.primaryColor
                    : themeStyle.primaryColor,
                fontFamily: "Montserrat",
                textDecoration: "underline",
              }}
            >
              Learn more about BGS World School
            </div>
          </div>
          {/* <div className="growth">
            <div
              style={{
                marginTop: "-650px",
                display: "flex",
                flexDirection: "column",
                width: "100%",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  marginTop: "100px",
                  display: "flex",
                  width: "100%",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    height: "500px",
                    width: "15%",
                    backgroundColor: "white",
                    zIndex: 3,
                  }}
                ></div>
                <div
                  style={{
                    height: "300px",
                    width: "70%",
                    backgroundColor: "white",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div
                    onClick={() => newsLeft()}
                    style={{
                      height: "40px",
                      width: "40px",
                      borderRadius: "10px",
                      backgroundColor:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryColor
                          : themeStyle.primaryColor,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      cursor: "pointer",
                      zIndex: 3,
                    }}
                  >
                    <ChevronLeftIcon
                      style={{ color: "white", fontSize: "40px" }}
                    />
                  </div>
                  <div
                    onClick={() => newsRight()}
                    style={{
                      height: "40px",
                      width: "40px",
                      borderRadius: "10px",
                      backgroundColor:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryColor
                          : themeStyle.primaryColor,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      cursor: "pointer",
                      zIndex: 3,
                    }}
                  >
                    <ChevronRightIcon
                      style={{ color: "white", fontSize: "40px" }}
                    />
                  </div>
                </div>
                <div
                  style={{
                    height: "500px",
                    width: "15%",
                    backgroundColor: "white",
                    zIndex: 3,
                  }}
                ></div>
              </div>
              <div
                className="newsSlider"
                style={{
                  marginTop: "-252px",
                  height: "5px",
                  width: "100%",
                  backgroundColor:
                    state.auth.theme == "dark"
                      ? themeStyleDark.primaryColor
                      : themeStyle.primaryColor,
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-around",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    marginTop: "180px",
                  }}
                >
                  <div
                    className="newsDot"
                    style={{
                      height: "15px",
                      width: "15px",
                      borderRadius: "15px",
                      marginTop: "65px",
                      backgroundColor:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryColor
                          : themeStyle.primaryColor,
                    }}
                  ></div>
                  <div
                    style={{
                      height: "25px",
                      width: "25px",
                      marginTop: "-20px",
                      borderRadius: "15px",
                      backgroundColor:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryColor
                          : themeStyle.primaryColor,
                    }}
                  ></div>
                  <div
                    style={{
                      textAlign :"justify",
                      fontSize: state.auth.isMobile ? "20px" : "30px",
                      fontWeight: "bold",
                      fontFamily: "Montserrat",
                    }}
                  >
                    1995
                  </div>
                  <div
                    style={{
                      textAlign :"justify",
                      width: "155px",
                      marginTop: "15px",
                      fontSize: "20px",
                      fontFamily: "Montserrat",
                    }}
                  >
                    SSLC Building was established at Our first building campus
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    marginTop: "180px",
                  }}
                >
                  <div
                    className="newsDot"
                    style={{
                      height: "15px",
                      width: "15px",
                      borderRadius: "15px",
                      marginTop: "65px",
                      backgroundColor:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryColor
                          : themeStyle.primaryColor,
                    }}
                  ></div>
                  <div
                    style={{
                      height: "25px",
                      width: "25px",
                      marginTop: "-20px",
                      borderRadius: "15px",
                      backgroundColor:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryColor
                          : themeStyle.primaryColor,
                    }}
                  ></div>
                  <div
                    style={{
                      textAlign :"justify",
                      fontSize: state.auth.isMobile ? "20px" : "30px",
                      fontWeight: "bold",
                      fontFamily: "Montserrat",
                    }}
                  >
                    1996
                  </div>
                  <div
                    style={{
                      textAlign :"justify",
                      width: "155px",
                      marginTop: "15px",
                      fontSize: "20px",
                      fontFamily: "Montserrat",
                    }}
                  >
                    SSLC Building was established at Our first building campus
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    marginTop: "180px",
                  }}
                >
                  <div
                    className="newsDot"
                    style={{
                      height: "15px",
                      width: "15px",
                      borderRadius: "15px",
                      marginTop: "65px",
                      backgroundColor:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryColor
                          : themeStyle.primaryColor,
                    }}
                  ></div>
                  <div
                    style={{
                      height: "25px",
                      width: "25px",
                      marginTop: "-20px",
                      borderRadius: "15px",
                      backgroundColor:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryColor
                          : themeStyle.primaryColor,
                    }}
                  ></div>
                  <div
                    style={{
                      textAlign :"justify",
                      fontSize: state.auth.isMobile ? "20px" : "30px",
                      fontWeight: "bold",
                      fontFamily: "Montserrat",
                    }}
                  >
                    1997
                  </div>
                  <div
                    style={{
                      textAlign :"justify",
                      width: "155px",
                      marginTop: "15px",
                      fontSize: "20px",
                      fontFamily: "Montserrat",
                    }}
                  >
                    SSLC Building was established at Our first building campus
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    marginTop: "180px",
                  }}
                >
                  <div
                    className="newsDot"
                    style={{
                      height: "15px",
                      width: "15px",
                      borderRadius: "15px",
                      marginTop: "65px",
                      backgroundColor:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryColor
                          : themeStyle.primaryColor,
                    }}
                  ></div>
                  <div
                    style={{
                      height: "25px",
                      width: "25px",
                      marginTop: "-20px",
                      borderRadius: "15px",
                      backgroundColor:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryColor
                          : themeStyle.primaryColor,
                    }}
                  ></div>
                  <div
                    style={{
                      textAlign :"justify",
                      fontSize: state.auth.isMobile ? "20px" : "30px",
                      fontWeight: "bold",
                      fontFamily: "Montserrat",
                    }}
                  >
                    1998
                  </div>
                  <div
                    style={{
                      textAlign :"justify",
                      width: "155px",
                      marginTop: "15px",
                      fontSize: "20px",
                      fontFamily: "Montserrat",
                    }}
                  >
                    SSLC Building was established at Our first building campus
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    marginTop: "180px",
                  }}
                >
                  <div
                    className="newsDot"
                    style={{
                      height: "15px",
                      width: "15px",
                      borderRadius: "15px",
                      marginTop: "65px",
                      backgroundColor:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryColor
                          : themeStyle.primaryColor,
                    }}
                  ></div>
                  <div
                    style={{
                      height: "25px",
                      width: "25px",
                      marginTop: "-20px",
                      borderRadius: "15px",
                      backgroundColor:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryColor
                          : themeStyle.primaryColor,
                    }}
                  ></div>
                  <div
                    style={{
                      textAlign :"justify",
                      fontSize: state.auth.isMobile ? "20px" : "30px",
                      fontWeight: "bold",
                      fontFamily: "Montserrat",
                    }}
                  >
                    1999
                  </div>
                  <div
                    style={{
                      textAlign :"justify",
                      width: "155px",
                      marginTop: "15px",
                      fontSize: "20px",
                      fontFamily: "Montserrat",
                    }}
                  >
                    SSLC Building was established at Our first building campus
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    marginTop: "180px",
                  }}
                >
                  <div
                    className="newsDot"
                    style={{
                      height: "15px",
                      width: "15px",
                      borderRadius: "15px",
                      marginTop: "65px",
                      backgroundColor:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryColor
                          : themeStyle.primaryColor,
                    }}
                  ></div>
                  <div
                    style={{
                      height: "25px",
                      width: "25px",
                      marginTop: "-20px",
                      borderRadius: "15px",
                      backgroundColor:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryColor
                          : themeStyle.primaryColor,
                    }}
                  ></div>
                  <div
                    style={{
                      textAlign :"justify",
                      fontSize: state.auth.isMobile ? "20px" : "30px",
                      fontWeight: "bold",
                      fontFamily: "Montserrat",
                    }}
                  >
                    2000
                  </div>
                  <div
                    style={{
                      textAlign :"justify",
                      width: "155px",
                      marginTop: "15px",
                      fontSize: "20px",
                      fontFamily: "Montserrat",
                    }}
                  >
                    SSLC Building was established at Our first building campus
                  </div>
                </div>
              </div>
            </div>
          </div> */}
          <div className="aboutabout2" style={{ marginTop: "-300px" }}>
            <Grid container spacing={5}>
              <Grid item xs={12} sm={12} md={12} lg={7} xl={7}>
                <div
                  style={{
                    fontSize: state.auth.isMobile ? "20px" : "30px",
                    fontFamily: "Montserrat",
                    textAlign: "left",
                    color:
                      state.auth.theme == "dark"
                        ? themeStyleDark.primaryColor
                        : themeStyle.prtmaryColor,
                    fontWeight: "bold",
                  }}
                >
                  Welcome To BGS World School
                </div>
                <br />
                <div
                  style={{
                    fontSize: state.auth.isMobile ? "16px" : "20px",
                    fontFamily: "Montserrat",
                    textAlign: "justify",
                  }}
                >
                  1. The location of a school has an enormous significance; our
                  school is far away from the noises and the pollution. The
                  ambience is calm, spacious with good amenities and utilities
                  in a visually appealing landscape. <br /> <br /> 2. The
                  backbone of any school’s infrastructure is the classroom. We
                  have adequate classrooms which are pleasant with modern
                  learning experience.
                  <br /> <br /> 3. Enriching young minds with value based
                  Education. We strive to offer true education that teaches and
                  imbibes universal values and morals, builds courage, instills
                  self-confidence, and fosters a sense of responsibility in the
                  children. <br /> <br />
                  4. A competent teacher plays a vital role in the growth of the
                  child. Our teachers are highly qualified, value-driven,
                  passionate and experienced. <br /> <br />
                  5. The events and activities are part of the curriculum which
                  aims at instilling discipline, ethics and values in students
                  that would help them to develop their personality to become
                  better citizens of the world.
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    margin: "30px 0px 10px 0px",
                  }}
                >
                  <Link
                    style={{
                      textDecoration: "none",
                      color:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryButtonTextColor
                          : themeStyle.primaryButtonTextColor,
                    }}
                    to={"/about_school"}
                  >
                    <Button
                      style={{
                        padding: "30px",
                        border:
                          "2px " + state.auth.theme == "dark"
                            ? themeStyleDark.primaryColor
                            : themeStyle.primaryColor + " solid",
                        borderRadius: "45px",
                        height: "30px",
                        fontSize: "20px",
                        fontWeight: "bold",
                        color:
                          state.auth.theme == "dark"
                            ? themeStyleDark.primaryColor
                            : themeStyle.primaryColor,
                      }}
                    >
                      Read More
                    </Button>
                  </Link>
                </div>
              </Grid>

              <Grid item xs={12} md={5}>
                <div className="slider">
                  <div className="slides-container">
                    <div className="slides-inner">
                      <div className="slide">
                        <img
                          style={{
                            width: "100%",
                            objectFit: "cover",
                            margin: "10px",
                            height: "100%",
                          }}
                          src={require("../img/inde/inde (2).jpeg")}
                        />
                      </div>
                      <div className="slide">
                        <img
                          style={{
                            width: "100%",
                            objectFit: "cover",
                            margin: "10px",
                            height: "100%",
                          }}
                          src={require("../img/poora/poora (2).jpeg")}
                        />
                      </div>
                      <div className="slide">
                        <img
                          style={{
                            width: "100%",
                            objectFit: "cover",
                            margin: "10px",
                            height: "100%",
                          }}
                          src={require("../img/janma/janma (2).jpeg")}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className="controls"
                    style={{ display: state.auth.isMobile ? "none" : "block" }}
                  >
                    <Button
                      className="button-carousel"
                      id="prevButton"
                      style={{
                        border: "2px solid " + themeStyle.primaryColor,
                        borderRadius: "25px",
                        height: "30px",
                        fontSize: "15px",
                        color: themeStyle.primaryColor,
                        fontWeight: "bold",
                        padding: "2px 10px 0px 10px",
                      }}
                    >
                      Prev
                    </Button>

                    <Button
                      className="button-carousel"
                      id="nextButton"
                      style={{
                        marginLeft: "15px",
                        border: "2px solid " + themeStyle.primaryColor,
                        borderRadius: "25px",
                        height: "30px",
                        fontSize: "15px",
                        color: themeStyle.primaryColor,
                        fontWeight: "bold",
                        padding: "2px 10px 0px 10px",
                      }}
                    >
                      Next
                    </Button>
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>
          <div
            className="aboutabout2"
            style={{ marginTop: state.auth.isMobile ? "-300px" : "-150px" }}
          >
            <Grid container spacing={5}>
              <Grid item xs={12} md={5}>
                <img
                  style={{
                    width: "100%",
                    objectFit: "cover",
                    margin: "10px",
                    marginLeft: state.auth.isMobile ? "-10px" : "0px",
                  }}
                  src={require("../img/bgsimg (13).jpeg")}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={7} xl={7}>
                <div
                  style={{
                    fontSize: state.auth.isMobile ? "16px" : "22px",
                    fontFamily: "Montserrat",
                    textAlign: "justify",
                  }}
                >
                  <div
                    style={{
                      fontSize: "32px",
                      fontFamily: "Montserrat",
                      textAlign: "justify",
                      color:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryColor
                          : themeStyle.primaryColor,
                      fontWeight: "bold",
                    }}
                  >
                    Our Vision
                  </div>
                  <br />
                  <div
                    style={{
                      fontSize: state.auth.isMobile ? "16px" : "22px",
                      fontFamily: "Montserrat",
                      textAlign: "justify",
                    }}
                  >
                    We envision a future where our students are equipped with
                    the skills, values, and commitment to serve, thrive in an
                    ever-evolving, interconnected world, and create a brighter
                    tomorrow for themselves and their community.
                  </div>
                  <br />

                  <div
                    style={{
                      fontSize: "32px",
                      fontFamily: "Montserrat",
                      textAlign: "justify",
                      color:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryColor
                          : themeStyle.primaryColor,
                      fontWeight: "bold",
                    }}
                  >
                    Our Mission
                  </div>
                  <br />
                  <div
                    style={{
                      fontSize: state.auth.isMobile ? "16px" : "22px",
                      fontFamily: "Montserrat",
                      textAlign: "justify",
                    }}
                  >
                    Our mission is to Empower young minds to flourish in the
                    21st century to foster community of curious, compassionate
                    and courageous leaders. We integrate academic excellence
                    with Spiritual growth, Sanskaras, Social responsibility,
                    develop effective communication, and inspiring to become
                    enlightened global citizens.
                  </div>
                </div>
              </Grid>
            </Grid>
            <div
              style={{
                textAlign: "justify",
                marginTop: "50px",
                fontSize: state.auth.isMobile ? "16px" : "22px",
              }}
            >
              Our focus is to develop our students as global citizens, with
              tolerance, respect, and appreciation of diverse cultures and
              religions for a lifetime learning experience. They should be
              self-motivated, independent, confident decision makers to take up
              leadership roles in the future. At our school, we provide an
              environment and curriculum where children can explore and develop
              every aspect of their lives. In other words, this unique
              educational institution seeks to blend the beauty of traditional
              cultural values and the latest in teaching aids and methodology to
              optimize learning, open young minds and empower young people to
              become global citizens, who stand tall and live with courage and
              conviction, carving a niche for themselves wherever they go.We
              opine that an ideal school system should be characterized by
              flexibility which makes it adaptable to changes.
              <br /> <br />
              It should be a place....
              <br /> - Where Learning is an integrated activity and encourages
              children to link it with their everyday lives in some way. <br />-
              Which promote thoughts that encourage creative thinking. e Where
              learning builds capacity to create new knowledge. <br />
              - Where the "future" of the child should never take centre stage
              against the child's "present".
              <br />
              <br />
              <br />
            </div>
          </div>
          <Benchmark />
          <div className="news">
            <div
              style={{
                textAlign: "center",
                marginBottom: "50px",
                marginTop: "50px",
                fontSize: state.auth.isMobile ? "30px" : "40px",
                fontWeight: "bold",
                fontFamily: "Montserrat",
                color:
                  state.auth.theme == "dark"
                    ? themeStyleDark.primaryColor
                    : themeStyle.primaryColor,
              }}
            >
              A Glimpse of the Campus
            </div>
            <Grid container spacing={2.5} style={{ marginBottom: "100px" }}>
              {images.map((gal, index) => (
                <Grid item xs={12} sm={12} md={6} lg={3} xl={3} key={index}>
                  <div className="icard">
                    <img
                      style={{
                        width: "300px",
                        height: "250px",
                        borderRadius: "10px",
                        objectFit: "contain",
                      }}
                      src={gal.image} // Use the imported image directly
                      alt={gal.title}
                    />
                  </div>
                </Grid>
              ))}
            </Grid>
          </div>
          <Explore />
          <VisitUs />
          <Footer />
        </div>
      );
    }
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        opacity: transition ? 1 : 0,
      }}
    >
      {getContent()}
    </div>
  );
}
